import ApiService from "./apiService";
import { Webhook, WebhookRequest } from "../types/webhook.type";

const endpoint = "/api/v1/negocios/webhooks";

class WebhooksService extends ApiService {
  getWebhook() {
    return this.get<Webhook | null>(endpoint, {
      auth: true,
      negocioActivo: true,
    });
  }

  createWebhook(data: WebhookRequest) {
    return this.post<Webhook>(endpoint, data, {
      auth: true,
      negocioActivo: true,
    });
  }

  updateWebhook(data: WebhookRequest) {
    return this.put<Webhook>(endpoint, data, {
      auth: true,
      negocioActivo: true,
    });
  }

  deleteWebhook() {
    return this.del(endpoint, {
      auth: true,
      negocioActivo: true,
    });
  }
}

const webhooksService = new WebhooksService();
export default webhooksService;

